export default __webpack_public_path__ + "static/media/Sunscream.d8793979.png";